import { useQuery } from '@tanstack/react-query'
import { getEmbarkationList } from "../api/embarkation"

export const _EMBARKATION_LIST = 'embarkation-list'
export const useGetEmbarkationList = () => {
    return useQuery([_EMBARKATION_LIST], getEmbarkationList, { staleTime: 300000 })
}